import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-patient-disabled-modal',
  templateUrl: './patient-disabled-modal.component.html',
  styleUrls: ['./patient-disabled-modal.component.scss']
})
export class PatientDisabledModalComponent {
  // Inputs - set by DynamicModalService via config.data
  @Input() patient: any;
  @Input() isPatientDisabled: boolean = true;

  // This method is injected by DynamicModalService - initialized with empty function
  modalClose: (result?: any) => void = () => {};

  /**
   * Called when register-new-patient emits close event
   * Event structure: { patientId, patients, action }
   */
  public handleClose(event: any): void {
    if (event?.patientId) {
      this.modalClose({ action: 'RETRY', patientId: event.patientId });
    } else {
      this.modalClose({ action: 'CANCEL' });
    }
  }
}

